import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrimaryButton from "../../../../Atoms/Buttons/Primary/PrimaryButton";
import { icons } from "../../../../../Assets/AssetHelper";
import DeleteModal from "../../../General/Models/DeleteModal";
import "./RolesList.css";
import { deleteRole } from "../../../../../Contexts/APIs/Users/Roles";
import CustomPagination from "../../../../Atoms/Pagination/Pagination";
import { withTranslation } from "react-i18next";

function RolesList({
  t,
  rolesData,
  setRolesData,
  setOpenLoader,
  count,
  page,
  handlePageChange,
  usersPrivilages,
  updatePagination,
}) {
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedRole, setSelectedRole] = useState(false);
  const navigate = useNavigate();
  const userType = localStorage.getItem("userType");
  let [searchParams, setSearchParams] = useSearchParams();

  let pageNumber =
    +searchParams.get("page") == 0 ? 1 : +searchParams.get("page");
  const handelDeleteRole = async () => {
    const { res, err } = await deleteRole(selectedRole?.role?.id);
    setOpenLoader(true);
    if (res) {
      let newData = rolesData?.filter(
        (val) => val?.id != selectedRole?.role?.id
      );
      setRolesData(newData);
      setOpenLoader(false);
    } else {
      setOpenLoader(false);
    }
  };

  return (
    <Grid container>
      <Grid container className="table-header mb-20px">
        <Grid item md={0.5}></Grid>
        <Grid item md={9.5}>
          {t("users.userRole")}
        </Grid>
        <Grid item sm={2} sx={{ pl: 1 }}>
          {t("users.action")}
        </Grid>
      </Grid>

      {rolesData?.length === 0 && (
        <Grid container display="block" textAlign="center">
          <img src={icons.Roles} alt="Users" />
          <Typography fontSize="30px" fontWeight="bold" color="#333132">
            {t("users.noRoles")}
          </Typography>
        </Grid>
      )}

      {rolesData?.length >= 1 && (
        <>
          {rolesData?.map((item, index) => {
            return (
              <Grid
                key={index}
                container
                item
                lg={12}
                className="role-item mb-20px"
                onClick={() => setSelectedRole({ role: item, index: index })}
              >
                <Grid item className="role-item-no" md={0.5} textAlign="center">
                  {item.id}
                </Grid>
                <Grid item className="role-item-name" md={9.5}>
                  {item.name}
                </Grid>
                <Grid item container sm={2} columnGap={1}>
                  <Grid item xs={3} textAlign="center">
                    {userType !== "descendant_user" && (
                      <PrimaryButton
                        classBtn="role-item-button"
                        btnType="icon"
                        startIcon={
                          <img width="35" src={icons.EditIcon} alt="edit" />
                        }
                        click={() =>
                          navigate(
                            `/users/roles/edit/${item.id}?page=${pageNumber}`
                          )
                        }
                      />
                    )}
                    {userType === "descendant_user" &&
                      usersPrivilages?.can_update && (
                        <PrimaryButton
                          classBtn="role-item-button"
                          btnType="icon"
                          startIcon={
                            <img width="35" src={icons.EditIcon} alt="edit" />
                          }
                          click={() =>
                            navigate(
                              `/users/roles/edit/${item.id}?page=${pageNumber}`
                            )
                          }
                        />
                      )}
                  </Grid>
                  <Grid item xs={3} textAlign="center">
                    {userType !== "descendant_user" && (
                      <PrimaryButton
                        classBtn="role-item-button"
                        btnType="icon"
                        startIcon={
                          <img width="35" src={icons.DeleteIcon} alt="delete" />
                        }
                        click={() => setOpenDeleteModel(true)}
                      />
                    )}
                    {userType === "descendant_user" &&
                      usersPrivilages?.can_delete && (
                        <PrimaryButton
                          classBtn="role-item-button"
                          btnType="icon"
                          startIcon={
                            <img
                              width="35"
                              src={icons.DeleteIcon}
                              alt="delete"
                            />
                          }
                          click={() => setOpenDeleteModel(true)}
                        />
                      )}
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
          {count > 10 && (
            <Grid
              container
              item
              justifyContent={"center"}
              xs={12}
              mb={7.5}
              mt={5}
            >
              <CustomPagination
                count={Math.ceil(count / 10)}
                size="large"
                shape="rounded"
                page={page}
                handleChange={handlePageChange}
                className="pagination"
                updatePagination={updatePagination}
              />
            </Grid>
          )}
        </>
      )}

      {openDeleteModel && (
        <DeleteModal
          open={openDeleteModel}
          setOpen={setOpenDeleteModel}
          handelDeleteRequest={() => {
            handelDeleteRole(selectedRole?.role?.id);
            setOpenDeleteModel(false);
          }}
          text={[t("users.deleteRole"), t("users.deleteRoleMsg")]}
          buttonText={[t("users.cancel"), t("users.delete")]}
        />
      )}
    </Grid>
  );
}
export default withTranslation()(RolesList);
